import React from "react";

export default function BasicSummary({ course }) {
  return (
    <>
      {course?.description && (
        <div className="fa-card at_a_glance">
          <div className="details-textarea">
            {course?.description ? (
              <div
                className="description"
                dangerouslySetInnerHTML={{ __html: course.description }} >
              </div>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
}
